const QuickbookSyncMessageComponent = ({ type }) => {
  return (
    <div className="row align-center">
      <div
        style={{
          border: "1px solid",
          padding: "10px 10px",
          borderRadius: "5px",
          width: "fit-content",
          margin: "15px",
        }}
      >
        We noticed that <strong>QuickBooks synchronization is currently disabled</strong> in the
        Sync Settings for <strong>{type}</strong>. Please enable it to proceed
        with syncing data to QuickBooks.
      </div>
    </div>
  );
};

export default QuickbookSyncMessageComponent;
